<template>
  <one-column-sidebar-left
      :id="$route.params.id"
      back-button-tab-selector="teambackbutton"
      sub-menu-selector="adminpanel"
      tab-selector="teamtab"
      type="team"
  >
    <info-panel :id="$route.params.id"
                slot="sidebarLeft"
                :created="$store.getters.getTeamCreationDate($route.params.id)"
                :downloadable="true"
                :image-editable="true"
                :last-change="$store.getters.getTeamChangeDate($route.params.id)"
                :organization="$store.getters.getTeamOrganization($route.params.id)"
                :preview-uri="$store.getters.getTeamPreviewUri($route.params.id)"
                :removable="true"
                preview-id="teamEdit"
                upload-type="Team"
    />

    <div slot="mainContent">
      <h1>
        <icon class="mr-1" size="0.9" type="users"/>
        {{ $store.getters.getTeamDisplayName(id) }}
      </h1>
      <p>({{ $store.getters.getTeamName(id) }})</p>
      <p v-if="$store.getters.getTeamOwner(id)">
        {{ $t('owner') }}: {{
          $store.getters.getUserById($store.getters.getTeamOwner(id)) ? $store.getters.getUserById($store.getters.getTeamOwner(id)).name : $store.getters.getTeamOwner(id)
        }}</p>
      <content-field-block
          :id="$route.params.id"
          :value="$store.getters.getTeamDisplayName(id)"
          class="mb-2 mt-3"
          field-name="displayName"
          input-type="text"
          label="displayName"
          store-name="Team"
      />
      <content-description-block
          :id="$route.params.id"
          :value="$store.getters.getTeamDescription(id)"
          store-name="Team"
      />

      <div>
        <div class="team-vis p-3 mt-2 mb-2 border-radius">
          <h2>{{ $t('Visibility') }}</h2>
          Attention: if you set this to global, newly created users will automatically be editor member of this team
          <div class="w-100"/>
          <team-visibility-dropdown
              :allow-null-value="false"
              :initial-value="$store.getters.getTeamVisibility(id)"
              class="w-50"
              @update="(val) => {update('visibility', val)}"
          />
          <h2 class="mt-4">{{ $t('members') }}</h2>
          <tag
              v-for="(member, index) in members"
              :key="index"
              :is-removable="true"
              :name="member.user.name"
              :tag="member" icon-left="home" @removeTag="removeUser">
            <role-selector
                :pre-selected-role="member.role"
                class="mt-2 mb-2"
                @update="(role) => updateRole(role, member.user.id)"
            />
          </tag>
          <universal-selector
              :exclude-from-item-list="members.map(item => {return {id: item.userId}})"
              :list-name="'teamEdit' + $route.params.id"
              class="mt-3"
              filter-attribute="name"
              store-name="User"
              @addItem="addUser"
          />
        </div>
      </div>

    </div>
  </one-column-sidebar-left>
</template>

<script>
import InfoPanel from "../components/InfoPanel";
import OneColumnSidebarLeft from "../layouts/OneColumnSidebarLeft";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import UniversalSelector from "@/components/organizations/UniversalSelector";
import Tag from "@/components/Tag";
import RoleSelector from "@/components/organizations/RoleSelector";
import ContentFieldBlock from "@/components/ContentFieldBlock";
import Icon from "../components/Icon";
import TeamVisibilityDropdown from "@/components/organizations/TeamVisibilityDropdown.vue";

export default {
  name: 'TeamEdit',
  components: {
    InfoPanel,
    OneColumnSidebarLeft,
    ContentDescriptionBlock,
    UniversalSelector,
    Tag,
    RoleSelector,
    ContentFieldBlock,
    TeamVisibilityDropdown,
    Icon
  },
  data() {
    return {
      id: '',
      members: [],
    };
  },
  beforeMount() {
    this.loadTeam();
    this.loadTeamMembers();
    this.id = this.$route.params.id;
  },
  methods: {
    update(fieldname, value) {
      this.$store.dispatch('updateTeam', {
        id: this.$route.params.id,
        visibility: value
      }).then(() => {
        this.loadTeam();
      })
    },
    loadTeam() {
      this.$store.dispatch('loadTeam', {
        id: this.$route.params.id,
      }).catch(e => {
        if (e.status === 401) {
          this.$router.push('/access-denied');
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    loadTeamMembers() {
      this.$store.dispatch('clientLoadTeamMembers', {
        id: this.$route.params.id,
        include: ['users']
      }).then(data => {
        this.members = data;
      });
    },
    addUser(user) {
      this.$store.dispatch('clientAddTeamMember', {
        id: this.$route.params.id,
        cid: user.id,
        args: {
          role: 'viewer'
        }
      }).then(() => {
        this.loadTeamMembers();
      });
    },
    removeUser(user) {
      this.$store.dispatch('clientRemoveTeamMember', {
        id: this.$route.params.id,
        cid: user.userId,
      }).then(() => {
        this.loadTeamMembers();
      });
    },
    updateRole(role, userId) {
      this.$store.dispatch('clientUpdateTeamMember', {
        id: this.$route.params.id,
        cid: userId,
        role: role
      }).then(() => {
        this.loadTeamMembers();
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.team-vis {
  background-color: var(--vform-editor-ui-secondary-color);
}
</style>